export enum LinkActionStatus {
    none,
    refreshing,
    refreshFailed,
    refreshSucceeded,
}
